var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ButtonBack",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":require(("@images/common/" + _vm.locale + "/btn_back.png")),"alt":_vm.$t('common.footer-005')}})])}
var staticRenderFns = []

export { render, staticRenderFns }